import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { AttendanceReportDaily } from './Pages';

export const AttendanceReportDailyRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={AttendanceReportDaily} />
        
    </Fragment>
)